<template>
    <div>
        <Tabs v-model="selectedTab" class="pt-tabs" name="composer" :animated="false">
            <TabPane label="Leave Requests" name="plan" tab="composer">
                <LeaveRequest></LeaveRequest>
            </TabPane>
            <TabPane label="Leave Credits" name="wrapup" tab="composer">
                <!-- iView mounts every pane up front; wait until the tab is first opened, then keep it -->
                <LeaveCredit v-if="creditsOpened"></LeaveCredit>
            </TabPane>
        </Tabs>
    </div>
</template>

<script>
import LeaveRequest from './LeaveRequest/index.vue';
import LeaveCredit from './LeaveCredit/index.vue';

export default {
    components: {
        LeaveRequest,
        LeaveCredit,
    },
    data() {
        return {
            selectedTab: 'plan',
            creditsOpened: false,
        };
    },
    watch: {
        selectedTab(tab) {
            if (tab === 'wrapup') this.creditsOpened = true;
        },
    },
};
</script>
<style lang="scss">
.requests-wrapper {
    .ivu-col {
        button {
            border-radius: 15px;
        }
    }
    .title-wrapper {
        display: block;

        .ivu-col {
            max-width: 100% !important;
        }
        .text-right {
            text-align: left;
            padding-top: 0 !important;
        }
    }
}
</style>
